import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    creating: -1,
    updating: -1,
  },
  id: '',
  error: null,
  configs: [],
  isFinish: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.HEALTH_SUMMARY_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.HEALTH_SUMMARY_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        id: payload.result.data,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
        error,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 0,
        },
        error: null,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 1,
        },
        id: payload.result.data,
        error: null,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_CREATE_FAILED:
      return {
        ...state,
        status: {
          creating: 2,
        },
        error,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 0,
        },
        error: null,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 1,
        },
        error: null,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 2,
        },
        error,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_CONFIG_GET_SUCCEED:
      return {
        ...state,
        configs: payload.data,
      };
    case ACTION_TYPES.HEALTH_SUMMARY_RESET:
      return { ...initialState, id: state.id, configs: state.configs };
    default:
      return state;
  }
}
